import { configureStore } from '@reduxjs/toolkit'
import userInfoSlice from './userInfoSlice'
import authTokenSlice from './authTokenSlice'

export default configureStore({
  reducer: {
    userInfo: userInfoSlice,
    authToken: authTokenSlice
  }
})